"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpResponseCodes;
(function (HttpResponseCodes) {
    HttpResponseCodes["OK"] = "200";
    HttpResponseCodes["NO_CONTENT"] = "204";
    HttpResponseCodes["BAD_REQUEST"] = "400";
    HttpResponseCodes["NOT_FOUND"] = "404";
    HttpResponseCodes["METHOD_NOT_ALLOWED"] = "405";
    HttpResponseCodes["IM_A_TEAPOT"] = "418";
})(HttpResponseCodes || (HttpResponseCodes = {}));
exports.default = HttpResponseCodes;
//# sourceMappingURL=http-response-codes.js.map